export default __webpack_public_path__ + "static/media/mahalaxmilogo.b110eceb.png";